import React, { Component } from 'react'
import c from 'classnames'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import PillButton from 'src/components/pill-button'
import FrameCloseBtn from 'src/components/frame-close-btn'

export class UseCaseIntroFrame extends Component {
  static propTypes = {
    className: PropTypes.string,
    currentUseCase: PropTypes.object,
  }

  static defaultProps = {
    className: '',
    currentUseCase: null,
  }

  state = {
    shouldShowFrames: false,
  }

  get className() {
    const { className } = this.props
    return c('im-use-case-intro-frame use-case-frame', className)
  }

  render() {
    const { className } = this
    const { currentUseCase } = this.props
    const { shouldShowFrames } = this.state
    return (
      <div className={className}>
        <FrameCloseBtn />
        <section className="frame-content">
          <div className="frame-shim" />
          <h2 className="frame-heading">{currentUseCase.buttonLabel}</h2>
          <section className="frame-description">{currentUseCase.introCopy}</section>
          <PillButton
            className="see-how-btn"
            onClick={() =>
              this.setState({
                shouldShowFrames: true,
              })
            }>
            See how it works
          </PillButton>
          <div className="frame-shim" />
        </section>
        <section className={c('frames', shouldShowFrames && 'visible')}>
          {
            <currentUseCase.frames
              useCase={currentUseCase}
              back={() => this.setState({ shouldShowFrames: false })}
            />
          }
        </section>
      </div>
    )
  }
}

export default connect(state => ({
  currentUseCase: state.currentUseCase,
}))(UseCaseIntroFrame)
